<template lang="html">
  <router-link tag="li" id="floorplan-tile"
    class="w-100 w-50-l w-third-xl pointer bb b--moon-gray pa3"
    :to="{ name: 'FloorplanDetail', params: { id: floorplan.id }}"
  >
    <div class="pa1">
      <floorplan-info :detail="floorplan.type.shortLabel" :label="'TYPE'"></floorplan-info>
      <!-- <floorplan-info :detail="floorplan.filter" :label="'BATH'"></floorplan-info> -->
      <floorplan-info :detail="floorplan.baths" :label="'BATH'"></floorplan-info>
      <floorplan-info :detail="floorplan.stacks[0].view[0]" :label="'VIEW'"></floorplan-info>
      <floorplan-info :detail="floorplan.interior" :label="'SQFT'"></floorplan-info>
    </div>
    <!-- <img class="ma3 h5" :src="getImage" /> -->
    <div class="pv4">
      <div id="floorplan-image" class="bg-center contain" :style="{'background-image': 'url(' + getImage + ')'} "></div>
    </div>
    <div class="flex justify-between items-end f5">
      <div class="flex items-center">
        <span class='d mr1 favourite' :class="{ active: floorplan.favourited, 'invisible': favourites.length >= maxFavourites }">
          <i class="material-icons interact-favourite" v-if="!floorplan.favourited" @click.stop="TOGGLE_FAVOURITE_PLAN(floorplan.id)">&#xE83A;</i>
          <i class="material-icons interact-favourite" v-if="floorplan.favourited" @click.stop="TOGGLE_FAVOURITE_PLAN(floorplan.id)">&#xE838;</i>
        </span>
        <span class='ml1 ttc font-futura-bold f4'
          v-html="floorplan.name"
        />
      </div>
      <v-link
        label="DETAILS"
        icon-code="keyboard_arrow_right"
        icon-pos="left"
        icon-class="f5 b"
        class="bg-transparent f7 tracked b black hover-action"
        :route="{ name: 'FloorplanDetail', params: { id: floorplan.id }}"
      />
    </div>
  </router-link>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LinkComponent from '@/components/Link';
import FloorplanListActionsComponent from './FloorplanListActions';
import FloorplanInfoComponent from './FloorplanInfo';
import FloorplanMixin from '../FloorplanMixin';

export default {
  data() {
    return {
      baseURL: 'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/'
    };
  },
  props: {
    floorplan: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
  },
  mixins: [FloorplanMixin],
  components: {
    'v-link': LinkComponent,
    'floorplan-list-actions': FloorplanListActionsComponent,
    'floorplan-info': FloorplanInfoComponent
  },
  computed: {
    ...mapGetters({
      floorplans: 'getFloorplans',
      favourites: 'favourites',
      maxFavourites: 'maxFavourites'
    }),
    getImage() {
      // return this.baseURL + this.floorplan.conditions[0].images.filter(img => img.type === 'fp')[0].url;
      return this.baseURL + this.floorplan.images.fp.url;
    },
  },
  methods: {
    ...mapActions([
      'TOGGLE_FAVOURITE_PLAN'
    ]),
    isEven(n) {
      return n === parseFloat(n) ? !(n % 2) : undefined;
    }
  }
};
</script>

<style lang="scss" scoped>
#floorplan-tile {
  &:active {
    background-color: $highlight-colour;
  }
  @media screen and (min-width: $breakpoint-large) and (max-width: $breakpoint-xlarge) {
    &:nth-child(odd) {
      border-right-style: solid;
      border-right-width: 1px;
    }
  }
  @media screen and (min-width: $breakpoint-xlarge) {
    &:nth-child(3n+2), &:nth-child(3n+1) {
      border-right-style: solid;
      border-right-width: 1px;
    }
  }

  #floorplan-image {
    height: 10rem;
  }

  span.favourite {
    &.invisible { visibility: hidden; }
    &.active { visibility: visible; }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanList/FloorplanListTile.vue